import React from 'react';
const PaperPlane = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='72.938' height='56.624' viewBox='0 0 72.938 56.624'>
      <g>
        <path
          fill='var(--theme-primary, #810ea9)'
          stroke='var(--theme-primary, #810ea9)'
          d='M74.639 15.254a9.468 9.468 0 0 0-1.185.287L6.444 37.849c-.026.008-.05.017-.076.027a2.2 2.2 0 0 0 .017 4.086c.026.011.054.02.081.029l17.762 5.666 7.362 21.869a1.1 1.1 0 0 0 .05.123 2.025 2.025 0 0 0 1.835 1.177h.075a1.982 1.982 0 0 0 1.36-.628 1.147 1.147 0 0 0 .217-.117l12.638-9.887 12.456 6.44a1.742 1.742 0 0 0 1.084.357 2.264 2.264 0 0 0 .572-.076 3.581 3.581 0 0 0 2.41-2.547l12.46-45.759a1.215 1.215 0 0 0 .032-.161l.054-.382c.043-.3.078-.562.087-.738a1.964 1.964 0 0 0-.505-1.692 2.042 2.042 0 0 0-1.776-.382zm-8.215 5.154L25.02 45.392 7.838 39.911zm-39.81 26.821l46.049-27.787.147-.087c-.428.479-.889.93-1.292 1.324L38.848 53.6a3.387 3.387 0 0 0-.874 1.518l-4.49 12.515zm10.068 18.588l3.436-9.581 5.3 2.743zm25.285-2.056a1.293 1.293 0 0 1-.571.778L41.55 54.277 73.1 22.491l.1-.1.049-.048z'
          transform='translate(-4.498 -7.703) translate(0 -7)'
        />
      </g>
    </svg>
  );
};

export default PaperPlane;
